import { createReducer, on } from '@ngrx/store';
import { clearUnidades, addUnidades, addUnidadesError, deleteUnidad, updateUnidad } from '../actions/unidades.actions';
import { initialUnidadesState } from '../../core/interfaces/models/unidad.interface';

export const unidadesReducer = createReducer(
  initialUnidadesState,
  // Agregar un estado completo de unidades
  on(addUnidades, (_, { unidadesState }) => ({
    ...unidadesState
  })),
  // Manejar error
  on(addUnidadesError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateUnidad, (state, { unidad }) => ({
    ...state,
    unidades: state.unidades.map(u =>
      u.id === unidad.id ? unidad : u
    )
  })),
  on(deleteUnidad, (state, { id }) => ({
    ...state,
    unidades: state.unidades.filter(u => u.id !== id)
  })),
  // Limpiar todo
  on(clearUnidades, () => initialUnidadesState)
);
